import { render, staticRenderFns } from "./LeadDetails.vue?vue&type=template&id=c0fd9934&scoped=true&"
import script from "./LeadDetails.vue?vue&type=script&lang=js&"
export * from "./LeadDetails.vue?vue&type=script&lang=js&"
import style0 from "./LeadDetails.vue?vue&type=style&index=0&id=c0fd9934&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0fd9934",
  null
  
)

export default component.exports